import React, { useEffect, useCallback, useState} from 'react';
import Colors from 'components/Colors.js';
import {newTransformation} from 'pattern/groups/stepGroups.js';
import TransformationEditor from "components/sidebar/TransformationEditor.js";
import {connect} from 'react-redux';
import '../../StepGroup.scss';

const colors = new Colors();

const StepGroupEditor = ({group, sequencerEngine, track}) => { 
    let [transformations, setTransformations] = useState(group.transformations);

    const onClickNew = useCallback(() => {
        newTransformation(group);
        setTransformations([... group.transformations]);
    }, [setTransformations, group]);

    let style = {
        backgroundColor: colors.getColorForHash(group.id)
    };
    return (
        <div className="step-group-editor">
          <div className="group-header">
            <div style={style} className="group-thumb"/>
            <div className="group-name">
              {group.name}
            </div>
            <div onClick={onClickNew} className="new-transform-btn">+</div>
          </div>
          {transformations.map(
              transformation =>
                  <TransformationEditor
                    key={transformation.id}
                    track={track}
                    sequencerEngine={sequencerEngine}
                    transformation={transformation}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepGroupEditor);
